import axios from 'axios';
import qs from 'qs';
import config from '../api/base';
import Vue from 'vue'
import { Toast } from 'cube-ui'
import weui from 'weui.js'
import {
	encryptBase64,
	encryptWithAes,
	generateAesKey,
	decryptWithAes,
	decryptBase64
} from '@/utils/crypto';
import {
	encrypt,
	decrypt
} from '@/utils/jsencrypt';
Vue.use(Toast);
import Cookies from "js-cookie";
// import {getToken} from '@/util/auth'
const encryptHeader = 'Encrypt-Key';
// 创建axios实例
const service = axios.create({
    baseURL: config.url, // api的base_url
    timeout: 100000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=utf-8',
        
    }
});

function toast(txt,type,time) {
    return Toast.$create({
        txt,
        type,
        time,
    });
}

// request拦截器
service.interceptors.request.use(config => {
 
    if (config.isEncrypt) {
      
        // config.headers['appId'] = keyList[config.appId];
        // config.headers['Isencrypt'] = 'true';
              const aesKey = generateAesKey();
              console.log(aesKey,'aesKey');
              console.log(encrypt(encryptBase64(aesKey)),'Encrypt-Key');
             
              config.headers[encryptHeader] = encrypt(encryptBase64(aesKey));
        
              config.headers["merId"] =config.merId;
              console.log( config.data ,'加密前');
              config.data = typeof config.data === 'object' ? encryptWithAes(JSON.stringify(config.data), aesKey) : encryptWithAes(config.data, aesKey);
              console.log( config.data ,'加密后');
      }
    toast('loading','loading',0).show();
    // if (config.method == 'GET') {
    //     config.data = qs.stringify(config.data);
    // }
    return config
}, error => {
    // Do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
    response => {
        toast().hide();
        /**
         * code为非200时抛错 可结合自己业务进行修改
         */
        console.log(response,'response');
        if (response.data.code === 200 || response.data.code === 0) {
            const keyStr = response.headers['encrypt-key'];
      
            
            // 加密
            if (keyStr != null && keyStr != '') {
              const data = response.data;
            //   console.log(data,'data');
              // 请求体 AES 解密
              const base64Str = decrypt(keyStr);
            //   console.log(base64Str,'base64Str');
              // base64 解码 得到请求头的 AES 秘钥
              const aesKey = decryptBase64(base64Str.toString());
            //   console.log(aesKey.words,'aesKey');
              // aesKey 解码 data
              const decryptData = decryptWithAes(data.data, aesKey);
            //   console.log(decryptData,'decryptData');
              // 将结果 (得到的是 JSON 字符串) 转为 JSON
            
              console.log(JSON.parse(decryptData),'JSON.parse(decryptData)');
              data.data=  JSON.parse(decryptData)
              return data
            }else{
              
                return response.data
            }
        } else {
            weui.dialog({
                title: '提示',
                content:  response.data.msg ||  response.data.message || '发生错误,请重试',
                className: 'custom-classname',
                buttons: [{
                    label: '确定',
                    type: 'primary',
                }]
            });
        }
        return response
    },
    error => {
        console.log('错误')
        // if(error.response.code === 401){
        //     toast(error.response.msg,1000)
        // }else if (error.response.code === 404) {
        //     toast(error.response.msg,1000)
        // }else if (error.response.code === 500) {
        //     toast(error.response.msg,1000)
        // } else{
        //     toast('网络故障',1000)
        // }
        return Promise.reject(error)
    }
);

export default service
